"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useColorScheme = void 0;

function useColorScheme() {
  // TODO: Support color schemes on web.
  return 'light';
}

exports.useColorScheme = useColorScheme;